import React               from 'react';
import { withRouter }      from 'react-router';
import { Link }            from "react-router-dom";
import { connect }         from 'react-redux';
import { Table }           from 'react-bootstrap';
import { Badge }           from 'react-bootstrap';
import { ClipLoader }      from 'react-spinners';
import CatalogBreadcrumb   from './Breadcrumb';
import { AwsConstants }    from '../../../utils/environment';
import { searchFetchData } from '../../../actions/catalog/search';

var apiHost = AwsConstants.WebApiHost;

class Result extends React.Component {
  
  search() {
    var search = this.props.location.pathname.replace(/^\/result\//, '');  
    return search;
  }

  componentDidMount() {
    var search = this.search();
    this.props.fetchData(apiHost, search);
  }

  render() {
    if ((this.props.search.length === 0 && !this.props.isLoading) || !this.props.hasErrored) {
      return (
        <div>
          <CatalogBreadcrumb {...this.props} />
          <Table responsive>
            <thead>
              <tr>
                <th>results <Badge>0</Badge></th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </Table>
        </div>
      );        
    }
    else if (!this.props.isLoading && !this.props.hasErrored) { 
      return (
        <div>
          <CatalogBreadcrumb {...this.props} />
          {this.props.search.map((element, index) => (
            <div key={index}>
              <Link to={element.path}>
                <h2>{element.name}</h2>
              </Link>
              <span>{element.description}</span>
            </div>
          ))}
        </div>
      );
     }
     else {
       return (
        <ClipLoader
          color={'#072659'} 
          loading={this.props.isLoading} 
        />
       );
     }
  }
}

const mapStateToProps = state => {
  return {
    search: state.catalog.search.search,
    hasErrored: state.catalog.search.searchHasErrored,
    isLoading: state.catalog.search.searchIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, search) => dispatch(searchFetchData(host, search))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Result));
